webpackJsonp([80],{

/***/ 1219:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1220);


/***/ }),

/***/ 1220:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(157);

var _datetime2 = _interopRequireDefault(_datetime);

var _en = __webpack_require__(740);

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en', _en2.default);

/***/ })

},[1219]);


// WEBPACK FOOTER //
// app/datetime.en-73f115951801bd44df07.js